import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToDo from "./ToDo";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { useState, useEffect, useMemo } from "react";
import { useSnackBar } from "../contexts/SnackBarContext";
import { useToDos, useDispatch } from "../contexts/ToDoContext";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ToDoList() {
  const toDos = useToDos();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [dialogToDo, setDialogToDo] = useState({
    title: null,
    description: null,
  });
  const { showHideSnackBar } = useSnackBar();

  const [todosType, setTodosType] = useState("all");

  // let filtersTodos = toDos;
  // if (todosType == "completed") {
  //   filtersTodos = toDos.filter((task) => {
  //     return task.isComplete;
  //   });
  // } else if (todosType == "not-completed") {
  //   filtersTodos = toDos.filter((task) => {
  //     return !task.isComplete;
  //   });
  // }

  const completedTodos = useMemo(() => {
    return toDos.filter((task) => {
      return task.isComplete;
    });
  }, [toDos]);

  const notCompletedTodos = useMemo(() => {
    return toDos.filter((task) => {
      return !task.isComplete;
    });
  }, [toDos]);

  let todosBeRendered = toDos;
  if (todosType == "completed") {
    todosBeRendered = completedTodos;
  } else if (todosType == "not-completed") {
    todosBeRendered = notCompletedTodos;
  } else {
    todosBeRendered = toDos;
  }

  function changeTodosType(e) {
    setTodosType(e.target.value);
  }

  function handleAddButton() {
    dispatch({ type: "added", payload: { title } });
    setTitle("");
    showHideSnackBar("تمت الإضافة بنجاح");
  }

  useEffect(() => {
    dispatch({ type: "get" });
  }, []);

  function handleUpdateDialogClose() {
    setOpenUpdateDialog(false);
  }

  function handleUpdateDialogOpen(todo) {
    setDialogToDo(todo);
    setOpenUpdateDialog(true);
  }

  function handledialogToDo() {
    dispatch({ type: "updated", payload: dialogToDo });
    setOpenUpdateDialog(false);
    showHideSnackBar("تم التحديث بنجاح");
  }

  function handleDeleteDialogOpen(todo) {
    setDialogToDo(todo);
    setOpenDeleteDialog(true);
  }

  function handleDeleteDialogClose() {
    setOpenDeleteDialog(false);
  }

  function handleConfirmDelete() {
    dispatch({ type: "deleted", payload: dialogToDo });
    setOpenDeleteDialog(false);
    showHideSnackBar("تم الحذف بنجاح");
  }

  const toDosList = todosBeRendered.map((task) => {
    return (
      <ToDo
        key={task.id}
        todo={task}
        openUpdateDialog={handleUpdateDialogOpen}
        openDeleteDialog={handleDeleteDialogOpen}
      />
    );
  });
  return (
    <>
      <Dialog
        style={{ direction: "rtl" }}
        open={openUpdateDialog}
        onClose={handleUpdateDialogClose}
      >
        <DialogTitle>تعديل مهمة</DialogTitle>
        <DialogContent sx={{ paddingBottom: 0 }}>
          <form>
            <TextField
              autoFocus
              margin="dense"
              name="title"
              type="text"
              fullWidth
              variant="standard"
              value={dialogToDo.title}
              onChange={(e) => {
                setDialogToDo({ ...dialogToDo, title: e.target.value });
              }}
            />

            <TextField
              autoFocus
              margin="dense"
              name="description"
              type="text"
              fullWidth
              variant="standard"
              value={dialogToDo.description}
              onChange={(e) => {
                setDialogToDo({ ...dialogToDo, description: e.target.value });
              }}
            />
            <DialogActions>
              <Button onClick={handleUpdateDialogClose}>اغلاق</Button>
              <Button onClick={handledialogToDo}>تأكيد</Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog
        style={{ direction: "rtl" }}
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"هل أنت متأكد من رغبتك في حذف هذه المهمة؟"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            لا يمكنك التراجع عن الحذف بعد إتمامه
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>إغلاق</Button>
          <Button onClick={handleConfirmDelete} autoFocus>
            نعم، قم بالحذف
          </Button>
        </DialogActions>
      </Dialog>
      <Container className="container" maxWidth="sm">
        <Card
          sx={{
            minWidth: 275,
            background: "white",
            marginTop: "40px",
            marginBottom: "40px",
            maxHeight: "80vh",
            overflow: "scroll",
          }}
        >
          <CardContent>
            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                fontSize: "50px",
                marginBottom: "20px",
              }}
            >
              مهامي
            </Typography>

            <Divider />

            <ToggleButtonGroup
              value={todosType}
              onChange={changeTodosType}
              exclusive={true}
              style={{ direction: "ltr" }}
              color="primary"
            >
              <ToggleButton value="not-completed" aria-label="left aligned">
                الغير منجز
              </ToggleButton>
              <ToggleButton value="completed" aria-label="centered">
                المنجز
              </ToggleButton>
              <ToggleButton value="all" aria-label="right aligned">
                الكل
              </ToggleButton>
            </ToggleButtonGroup>

            <Typography variant="h5" component="div">
              {toDosList}
            </Typography>

            <Grid container spacing={1} style={{ marginTop: "20px" }}>
              <Grid size={8}>
                <TextField
                  style={{
                    width: "100%",
                  }}
                  id="outlined-basic"
                  label="عنوان المهمة"
                  variant="outlined"
                  value={title}
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={4}>
                <Button
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  size="lg"
                  variant="contained"
                  onClick={handleAddButton}
                  disabled={title.length == 0}
                >
                  اضافة
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}
